import { Message } from '@/components/Message'

export default function scrollView () {
  Message({ text: '还有信息未填写' })
}
